// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.capitalize {
  text-transform: capitalize;
}

.mandatory-asterisk {
  color: red;
  vertical-align: middle;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

.module-form-label {
  font-weight: bold !important;
}
.module-form-label .mandatory-asterisk {
  font-weight: normal;
  display: inline-block;
  margin-top: 3px;
}

.create-view-dialog-content .dialog-body .project-form,
.create-view-dialog-content .dialog-body .task-form,
.create-view-dialog-content .dialog-body .fullkit-form {
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin: 0;
  border: 1px solid #dee2e6;
}
.create-view-dialog-content .dialog-body .project-form .form-check-input:focus,
.create-view-dialog-content .dialog-body .task-form .form-check-input:focus,
.create-view-dialog-content .dialog-body .fullkit-form .form-check-input:focus {
  box-shadow: none;
}
.create-view-dialog-content .dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-top: 1rem;
}
.create-view-dialog-content strong {
  text-transform: capitalize;
}

.p-dialog-header .p-dialog-title {
  font-size: 15px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/CreateViewDialog/CreateViewDialog.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;;AAEA;EACE,UAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;AACF;;AAEA;EACE,4BAAA;AACF;AACE;EACE,mBAAA;EACA,qBAAA;EACA,eAAA;AACJ;;AAMI;;;EAGE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;AAHN;AAKM;;;EACE,gBAAA;AADR;AAME;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;AAJJ;AAOE;EACE,0BAAA;AALJ;;AAUE;EACE,0BAAA;AAPJ","sourcesContent":[".capitalize {\n  text-transform: capitalize;\n}\n\n.mandatory-asterisk {\n  color: red;\n  vertical-align: middle;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n}\n\n.module-form-label {\n  font-weight: bold !important;\n\n  .mandatory-asterisk {\n    font-weight: normal;\n    display: inline-block;\n    margin-top: 3px;\n  }\n}\n\n.create-view-dialog-content {\n  .dialog-body {\n\n    .project-form,\n    .task-form,\n    .fullkit-form {\n      padding: 1rem;\n      background-color: #f8f9fa;\n      border-radius: 4px;\n      margin: 0;\n      border: 1px solid #dee2e6;\n\n      .form-check-input:focus {\n        box-shadow: none;\n      }\n    }\n  }\n\n  .dialog-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem;\n    padding-top: 1rem;\n  }\n\n  strong {\n    text-transform: capitalize;\n  }\n}\n\n.p-dialog-header {\n  .p-dialog-title {\n    font-size: 15px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
